var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"track-account-page-load",rawName:"v-track-account-page-load:retro-credit",arg:"retro-credit"}],staticClass:"retro-credit-page"},[_c('cmg-retro-credit',{staticClass:"retro-credit"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }